import type { RestaurantFormData } from "../../restaurant.types";
import MapComponent from "../MapComponent";

interface LocationProps{
    formData: RestaurantFormData;
    updateFormData: (updatedFields: Partial<RestaurantFormData>) => void;
}
const Location : React.FC<LocationProps> = ({ formData, updateFormData }) => (
    <div className="space-y-4">
        <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-3">Location Details</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
                Address *
            </label>
            <input
                type="text"
                value={formData.location.address}
                onChange={(e) => updateFormData({
                location: { ...formData.location, address: e.target.value }
                })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FFD166] focus:border-transparent"
                placeholder="Enter full address"
            />
            </div>

            <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
                Area / Neighborhood *
            </label>
            <input
                type="text"
                value={formData.location.area}
                onChange={(e) => updateFormData({
                location: { ...formData.location, area: e.target.value }
                })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FFD166] focus:border-transparent"
                placeholder="Enter area/neighborhood"
            />
            </div>
            <div>

            <label className="block text-sm font-medium text-gray-700 mb-1">
                City *
            </label>
            <input
                type="text"
                value={formData.location.city || ""}
                onChange={(e) => updateFormData({
                location: { ...formData.location, city: e.target.value }
                })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FFD166] focus:border-transparent"
                placeholder="Enter city name"
            />
            </div>
        </div>
        <span className="text-xs text-gray-500 mt-1">Click the map below to set the exact location of your restaurant.</span>
        {/* Map Component */}
        <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
            Set Location on Map *
            </label>
            <MapComponent
            locationData={{
                lat: formData.location.geo.coordinates[1],
                lng: formData.location.geo.coordinates[0],
                city: formData.location.city || "",
                address: formData.location.address,
                area: formData.location.area
            }}
            setLocationData={(newLocation) => {
                updateFormData({
                location: {
                    address: newLocation.address || formData.location.address,
                    area: newLocation.area || formData.location.area,
                    city: newLocation.city || formData.location.city,
                    geo: {
                    type: "Point",
                    coordinates: [newLocation.lng, newLocation.lat]
                    }
                }
                });
            }}
            height="400px"
            searchable={true}
            interactive={true}
            />
            <p className="text-xs text-gray-500 mt-2">
            💡 Click anywhere on the map or search for a location to set your restaurant's position
            </p>
        </div>
        </div>
    </div>
);

export default Location;